<template>
  <div style="min-height: 100vh; background-color: #f7f9fc; display: flex; flex-direction: column;">
    
    <div style="padding: 30px 0; display: flex; justify-content: center;">
      <img
        v-if="isMedall"
        src="@/assets/medall_logo.png"
        alt="Medall Diagnostics Logo"
        style="height: 80px;"
      />
    </div>

    <div style="flex-grow: 1; display: flex; align-items: center; justify-content: center;">
      <div style="text-align: center; max-width: 500px;">
        <h2 style="color: #d9534f; margin-bottom: 10px;">Link Expired</h2>
        <p style="font-size: 16px; color: #555; line-height: 1.6;">
          Thank you for clicking the link. The validity of the link has expired.
          <br />
          Please call and get the link validity extended.
        </p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "LinkExpiry",
  data(){
    return{
        isMedall: false,
    };
  },
  mounted(){
     if (window.location.href.includes("medall"))
    {
      document.title = "Medall";
      this.isMedall = true;
    }
  }
};
</script>

